import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { grey } from '@mui/material/colors'
import { hydratePathname } from '../../../util'
import { Resource } from '../../../types'
import { Route, RouteParameters } from '../../../constants'
import { useIsIFramed, useShops } from '../../../hooks'
import { useNavigate } from 'react-router'

type UserListProps = {
  shopId?: string
  resourceId?: string
}

const ResourceList = ({ shopId, resourceId }: UserListProps) => {
  const { data: shops } = useShops({ id: shopId }, { enabled: Boolean(shopId) })
  const navigate = useNavigate()
  const isIFramed = useIsIFramed()

  const shop = shops?.[0]
  const resourceOptions =
    shop?.resources.map((resource: Resource) => ({
      name: resource.name,
      id: resource.id,
    })) ?? []

  const handleResourceChange = (event: SelectChangeEvent<string>) => {
    const pathname = hydratePathname(Route.SHOP_SELECTED_RESOURCE_BLOCK_SCHEDULING, {
      [RouteParameters.COUNTRY]: shop?.country,
      [RouteParameters.RESOURCE_ID]: event.target.value,
      [RouteParameters.SHOP_ID]: shop?.id,
    })
    navigate(pathname)
  }

  // MUI seems to have removed 'notched' from select when using shrink with input, so need to use background color here
  const labelBackground = isIFramed ? 'white' : grey[100]

  return (
    <FormControl variant="outlined" sx={{ m: 1, marginLeft: 0, width: 300 }}>
      <InputLabel shrink={true} sx={{ background: labelBackground, padding: '0 3px 0 3px' }} id="resource-select-label">
        Selected Resource
      </InputLabel>
      <Select
        size="small"
        labelId="resource-select-label"
        id="resource-select"
        defaultValue={resourceId ?? ''}
        label="Selected Resource"
        displayEmpty
        name="resource-select"
        onChange={handleResourceChange}
      >
        {resourceOptions.map((resource) => (
          <MenuItem key={resource.id} value={resource.id}>
            {resource.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export { ResourceList }
